/// <amd-module name="Artifacts/Connect/tools/python/Protocol" />
import { PackagingService } from "Artifacts/Connect/services/PackagingService";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { IProtocol } from "Artifacts/Connect/types/IProtocol";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

export class PythonProtocol implements IProtocol {
  readonly name = "Python";
  readonly area = "pypi";

  // For pip, need this method named like this due to the interface.
  public getFeedUrl(packagingService: PackagingService, feed: ICombinedFeedView): string {
    return this.getReplacedRouteValues(packagingService, feed, "simple");
  }

  public getTwineFeedUrl(packagingService: PackagingService, feed: ICombinedFeedView): string {
    return this.getReplacedRouteValues(packagingService, feed, "upload");
  }

  public getReplacedRouteValues(
    packagingService: PackagingService,
    feed: ICombinedFeedView,
    resource: string,
  ): string {
    // TODO: Move route resolution to endpoints within this object
    const path = replaceRouteValues("_packaging/{feedId}/{area}/{resource}/{packageName}/", {
      feedId: feed.name,
      area: this.area,
      resource: resource,
    });

    return packagingService.getUrl(feed.project, path);
  }
}
